<script>
import Product from '@components/product'
import SubHeader from '@components/sub-header'

export default {
  name: 'UnavailableProducts',
  components: {
    Product,
    SubHeader,

  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div
    :class="$style.container">
    <SubHeader :text="componentData.title"/>

    <v-list
      :class="$style.container__vList"
      three-line>
      <Product
        v-for="(product, index) in componentData.products"
        :key="index"
        :product="product"
      />
    </v-list>
    <hr :class="$style.container__hr">
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';
.container {

  &__hr {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  &__vList {
    padding: 0;
  }

}
</style>
